import { ProductServices } from '@/services/product.service'

const state = {
  loading: false,
  dialog: false,
  overlay: false,
  produkmapping: [],
  totalprodukmapping: 0,
  mysupplier: []
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  getProductMapping ({ commit }, opt) {
    commit('setloading', true)
    localStorage.setItem('getproductmapping_value', JSON.stringify(opt))
    ProductServices.getProductMapping(opt).then(value => {
      commit('setloading', false)
      commit('setdata', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  deleteProductMapping ({ dispatch, commit }, id) {
    commit('setloading', true)
    ProductServices.deleteProductMapping(id).then(value => {
      commit('setloading', false)
      dispatch('alert/success', 'Delete Ok!', { root: true })
      var s = JSON.parse(localStorage.getItem('getproductmapping_value'))
      console.log(s)
      ProductServices.getProductMapping(s).then(value => {
        commit('setloading', false)
        commit('setdata', value)
      }).catch(reason => {
        console.log(reason)
        commit('setloading', false)
      })
    }).catch(reason => {
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  addProductmapping ({ dispatch, commit }, data) {
    commit('setloading', true)
    var sellerid = data.sellerid
    ProductServices.addProductmapping(data).then(value => {
      commit('setloading', false)
      dispatch('alert/success', 'Add Product Suplier Ok!', { root: true })
      dispatch('ProductStore/getSellerProducts', sellerid, { root: true })
      var s = localStorage.getItem('productview_productid')
      if (s) {
        dispatch('ProductStore/getProducPricingByProductId', s, { root: true })
      }
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  updateProductmapping ({ dispatch, commit }, data) {
    commit('setloading', true)
    ProductServices.updateProductmapping(data).then(value => {
      commit('setloading', false)
      dispatch('alert/success', 'Update Product Suplier Ok!', { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getMySupplier ({ commit }) {
    commit('setloading', true)
    ProductServices.getmysupplier().then(value => {
      commit('setloading', false)
      commit('setmysupplierdata', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setdata (state, s) {
    state.produkmapping = []
    state.produkmapping = s.data.content
    state.totalprodukmapping = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setmysupplierdata (state, s) {
    state.mysupplier = []
    state.mysupplier = s.data
  }
}

export const ProductMapping = {
  namespaced: true,
  state,
  actions,
  mutations
}
